import React from 'react';

import css from './DetailSection.module.css';

/**
 * Generic "label + value" section used in the ListingPage right column.
 * Used for "Materiale", "Lengde", and any other listing field surfaced as
 * a small heading + plain value row.
 *
 * Renders nothing when `value` is empty so the surrounding stack stays
 * tight on listings missing the field.
 *
 * @param {Object} props
 * @param {string} props.heading
 * @param {string|null|undefined} props.value
 * @returns {JSX.Element|null}
 */
const DetailSection = props => {
  const { heading, value } = props;

  if (!value) return null;

  return (
    <section className={css.root}>
      <h5 className={css.heading}>{heading}</h5>
      <p className={css.value}>{value}</p>
    </section>
  );
};

export default DetailSection;
